import { api } from '..';

export async function redeemCoupon(payload) {
  return api('POST', `/panel/coupons/redeem`, payload, {
    lang: payload.lang,
    code: payload.code
  });
}

export async function getCoupons(payload) {
  return api('GET', `/panel/coupons`, payload, {
    lang: payload.lang
  });
}
